import { render, staticRenderFns } from "./TicketCloseConfirm.vue?vue&type=template&id=085bfb8e"
import script from "./TicketCloseConfirm.vue?vue&type=script&lang=js"
export * from "./TicketCloseConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports